import { hasThemeDocumentShape, isRecord, isThemeDeployment, isThemeIssues } from './guards.utils';
import {
  NormalizeThemeArgs,
  NormalizeThemeRequestDto,
  ThemeManifestResponseDto,
  ThemeNormalizationResult,
} from './theme-contract.api.types';
import { ThemeDefaultPreset, ThemeManifest } from './types';

export const normalizeThemeBaseUrl = (baseUrl: string) => baseUrl.replace(/\/+$/, '');

export function toApiThemeValidation({ theme }: NormalizeThemeArgs): NormalizeThemeRequestDto {
  return theme;
}

function fromApiDefaultPreset(preset: unknown): ThemeDefaultPreset | null {
  if (
    !isRecord(preset) ||
    preset.id !== 'default' ||
    preset.kind !== 'system' ||
    typeof preset.name !== 'string' ||
    !hasThemeDocumentShape(preset.theme)
  ) {
    return null;
  }

  return { id: 'default', kind: 'system', name: preset.name, theme: preset.theme };
}

export function fromApiThemeManifest(body: unknown): ThemeManifest | null {
  const defaultPreset = isRecord(body) ? fromApiDefaultPreset(body.defaultPreset) : null;

  if (!isThemeDeployment(body) || !defaultPreset) return null;

  const surfaceDefaults = isRecord(body.surfaceDefaultPresets) ? body.surfaceDefaultPresets : {};
  const widgetPreset = fromApiDefaultPreset(surfaceDefaults.widget);

  return {
    contractHash: body.contractHash,
    supportedSchemaVersions: body.supportedSchemaVersions,
    supportedPreviewProtocolVersions: body.supportedPreviewProtocolVersions,
    capabilities: body.capabilities,
    defaultPreset,
    ...(widgetPreset ? { surfaceDefaultPresets: { widget: widgetPreset } } : {}),
  } satisfies ThemeManifestResponseDto;
}

export function fromApiThemeValidation(body: unknown): ThemeNormalizationResult | null {
  if (!isRecord(body)) return null;
  if (body.success === true && isThemeDeployment(body.deployment) && hasThemeDocumentShape(body.normalizedTheme)) {
    return { success: true, normalizedTheme: body.normalizedTheme, deployment: body.deployment };
  }
  if (body.success === false && isThemeIssues(body.issues)) {
    return {
      success: false,
      issues: body.issues,
      deployment: isThemeDeployment(body.deployment) ? body.deployment : undefined,
    };
  }
  return null;
}
